<template>
  <div>
    <h3 v-if="!(userid > 0)" class="title">添加学员</h3>
    <div class="main2">
      <BInputText
        label-text="姓名"
        :required="true"
        :maxLength="20"
        v-model="accountInfo.userName"
        placeholder="学员姓名"
      />
    </div>
    <div class="main2">
      <BInputText
        label-text="身份证号"
        :required="true"
        v-model="accountInfo.idCardNum"
        placeholder="学员身份证号"
        :maxLength="18"
        @changed="idCardNumCheck"
      />
    </div>
    <div class="main2">
      <BInputText
        label-text="手机号码"
        :required="true"
        v-model="accountInfo.telNo"
        placeholder="学员手机号码"
        :maxLength="18"
        @changed="telNoCheck"
      />
    </div>
    <div class="main2">
      <BInputText
        label-text="年龄"
        :disabled="true"
        v-model="accountInfo.age"
        placeholder="年龄"
      />
    </div>
    <div class="main2">
      <BInputPullDown
        label-name="性别"
        :disabled="true"
        v-model="accountInfo.sex"
        :Options="sexList"
        v-bind:readonly="true"
      />
    </div>
    <div class="main2">
      <label class="label">头像</label>
      <img
        :src="
          accountInfo.idPhotoUrl
            ? accountInfo.idPhotoUrl
            : require('@/assets/head_photo.png')
        "
        style="margin-top: 10px;"
        width="100px"
        height="100px"
        v-on:click="selectPhoto()"
      />
      <input
        class="hidden"
        type="file"
        ref="fileSelect"
        accept="image/*"
        @change="fileSelected"
      />
    </div>
    <div class="search-functions" v-if="userid > 0">
      <BBtnPrimary
        style="margin-right: 5px; margin-left: 5px"
        :clicked="doUpdate"
        hidden-key=""
        btn-txt="变更"
      />
      <BBtnPrimary
        style="margin-right: 5px; margin-left: 5px"
        :clicked="doBack"
        hidden-key=""
        btn-txt="返回"
      />
    </div>
    <div class="search-functions" v-else>
      <BBtnPrimary
        style="margin-right: 5px; margin-left: 5px"
        :clicked="doSave"
        hidden-key=""
        btn-txt="添加"
      />
      <BBtnPrimary
        style="margin-right: 5px; margin-left: 5px"
        :clicked="doBack"
        hidden-key=""
        btn-txt="返回"
      />
    </div>
  </div>
</template>
<script>
import {
  studentSave,
  studentUpdata,
  addCustomerFileUpload,
  editDetail,
  getStudentInfo,
} from "@/api/student";
import BInputText from "../../components2/BInputText";
import { upload } from "@/api/upload";
import BBtnPrimary from "../../components2/BBtnPrimary";
import Hub from "../../events/Hub";
import BInputPullDown from "../../components2/BInputPullDown";
import Vue from "vue";
export default {
  name: "CourseManagement",
  components: {
    BInputText,
    BBtnPrimary,
    BInputPullDown,
  },
  props: ["id","isHas","classId"],
  data() {
    return {
      accountInfo: {
        id: 0,
        userName: "",
        age: "",
        sex: "",
        idCardNum: "",
        telNo: "",
        idPhotoUrl: "",
        classId: "",
        studentId: "",
        uploadFlg: false,
      },
      sexList: [
        {
          value: "01",
          text: "男",
        },
        {
          value: "02",
          text: "女",
        },
      ],
      isMulti: true,
      timeout: 3000,
      userid: 0,
      display: true,
      snackbarText: "",
      snackbarColor: "success",
      data: "",
      dataT: {},
      createTime: "",
      data_isHas: 0,
      navi: [
        { name: "class-management" },
        { name: "student-management" },
        { name: "class-student-add" },
      ],
      
    };
  },
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  mounted () {
    if (this.$props.id !== null && this.$props.id !== undefined) {
      this.userid = this.$props.id;
      this.accountInfo.studentId = this.$props.id;
    }
    if (this.$props.classId !== null && this.$props.classId !== undefined) {
      this.accountInfo.classId = this.$props.classId;
    }
    if (this.$props.isHas !== null && this.$props.isHas !== undefined) {
      this.data_isHas = this.$props.isHas;
    }
    // 作为添加页面时，清除userId
    if (this.data_isHas == 0) {
      this.userid = ""
      this.accountInfo.studentId = ""
    }

    if (this.data_isHas == 1) {
      this.searchDetail();
    }

    this.$store.commit('SET_NAVI_DATA', this.navi);
    this.$nextTick(
      function () {
        Hub.$on("modal-confirm", this.set);
      }.bind(this)
    );

  },
  // 页面载入之前
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     const params = {
  //       userid: vm.$route.params.id,
  //       classId: vm.$route.params.classId,
  //       isHas: vm.$route.params.isHas,
  //     };
  //     if (
  //       params.classId != "" &&
  //       params.classId != null &&
  //       params.classId != undefined
  //     ) {
  //       vm.accountInfo.classId = params.classId;
  //     }
  //     if (
  //       params.isHas != "" &&
  //       params.isHas != null &&
  //       params.isHas != undefined
  //     ) {
  //       vm.isHas = params.isHas;
  //     }
  //     if (
  //       params.userid != "" &&
  //       params.userid != null &&
  //       params.userid != undefined
  //     ) {
  //       vm.userid = params.userid;
  //     }
  //     // 把不为空的参数存入缓存
  //     // if(params.userid !== null && params.userid !== '' && params.userid !== undefined){
  //     //   vm.$store.commit('SET_STUDENT_ADD_PARAMS', params)
  //     // }
  //     //vm.accountInfo.classId = vm.$store.state.studentAdd_classId;
  //     vm.accountInfo.studentId = vm.$store.state.studentAdd_studentId;
  //     // 查询条件赋值
  //     // if (vm.$store.state.studentAdd_userid !== undefined && vm.$store.state.studentAdd_userid !==
  //     //   null && vm.$store.state.studentAdd_userid !== '') {
  //     //   vm.userid = vm.$store.state.studentAdd_userid;
  //     //   vm.accountInfo.userName = vm.$store.state.studentAdd_userName;
  //     //   vm.accountInfo.idCardNum = vm.$store.state.studentAdd_idCardNum;
  //     //   vm.accountInfo.age = vm.$store.state.studentAdd_age;
  //     //   vm.accountInfo.sex = vm.$store.state.studentAdd_sex;
  //     //   vm.accountInfo.idPhotoUrl = vm.$store.state.studentAdd_idPhotoUrl;
  //     //   vm.createTime = vm.$store.state.studentAdd_createTime;
  //     //   vm.isHas = vm.$store.state.studentAdd_isHas;
  //     // }
  //     if (vm.isHas == 1) {
  //       vm.searchDetail();
  //     }
  //   });
  // },
  methods: {
    async searchDetail() {
      var param = {
        studentId: this.userid,
        classId: this.accountInfo.classId,
      };
      const data = await editDetail(param);
      this.accountInfo.userName = data.data.userName;
      this.accountInfo.idCardNum = data.data.idCardNum;
      this.accountInfo.telNo = data.data.telNo;
      this.accountInfo.age = data.data.age;
      this.accountInfo.userName = data.data.userName;
      this.accountInfo.idPhotoUrl = data.data.idPhotoUrl;
      this.accountInfo.sex = String(data.data.sex).toString();
    },
    // 返回
    doBack() {
      if (this.data_isHas == 0) {
        var obj1 = {
          flag: 2,
        }
        this.$emit("openFlag",obj1)
      } else if (this.data_isHas == 1) {
        var obj = {
          flag: "studentDetail",
        }
        this.$emit("openFlag",obj)
      }
    },

    //添加
    async doSave() {
      if(this.doItemCheck()){
        const data = await studentSave(this.accountInfo);
        if (data.code === 0) {
          Vue.prototype.$vsnackbar.show("添加成功");
          this.doBack();
        } else {
          this.snackbarText = data.msg;
          Vue.prototype.$valertbar.show(this.snackbarText);
        }
      }
    },

    //更新
    async doUpdate() {
      if(this.doItemCheck()){
        this.accountInfo.id = this.userid;
        const data = await studentUpdata(this.accountInfo);
        if (data.code === 0) {
          Vue.prototype.$vsnackbar.show("更新成功");
          this.doBack();
        } else {
          this.snackbarText = data.msg;
          Vue.prototype.$valertbar.show(this.snackbarText);
        }
      }
    },
    // 学员照片
    async getFilePhoto(file) {
      // 上传附件验证
      this.fileCheckList = this.comUtils.fileUploadCheck(file, "img");
      if (
        this.fileCheckList.snackbarText !== "" &&
        this.fileCheckList.snackbarText !== null &&
        this.fileCheckList.snackbarText !== undefined
      ) {
        this.snackbarText = this.fileCheckList.snackbarText;
        Vue.prototype.$vsnackbar.show(this.snackbarText);
        return;
      }
      var formData = new FormData();
      formData.append("file", file.target.files[0]);
      formData.append("uploadPath", "/idphoto");
      const data = await addCustomerFileUpload(formData);
      if (data.data !== null && data.data !== "") {
        this.trainerInfo.idPhotoUrl = data.data;
      }
    },
    // 项目验证
    doItemCheck() {
      // 验证
      this.snackbarText = "";
      // 姓名验证
      if (
        this.accountInfo.userName == null ||
        this.accountInfo.userName == ""
      ) {
        this.snackbarText = "姓名必须输入！";
        Vue.prototype.$valertbar.show(this.snackbarText);
        return false;
      }
      if (!this.comUtils.checkIdCardNo(this.accountInfo.idCardNum)) {
        this.snackbarText = "身份证号验证有误！";
        Vue.prototype.$valertbar.show(this.snackbarText);
        return false;
      }

      
      if(!this.telNoCheck(this.accountInfo.telNo)){
        Vue.prototype.$valertbar.show(this.messageText);
        return false;
      }
         
      // 身份证号码验证
      return this.idCardNumCheck(this.accountInfo.idCardNum);
    },
    // 手机号码验证
    async telNoCheck (telNo) {
      // 查询学员信息,重置
      // this.accountInfo.userName = ""
      // this.accountInfo.idPhotoUrl = ""
      // this.accountInfo.age = ""
      // this.accountInfo.sex = ""

      // 验证
      this.messageText = ''
      if (telNo === null || telNo === '') {
        this.messageText = '手机号必须输入！'
        return false
      }
      if (!this.comUtils.checkTelNo(telNo)) {
        this.messageText = '手机号验证有误！'
        return false
      }

      // 查询学员信息
      const data = await getStudentInfo("",telNo);
      if (data.data != null) {
        this.accountInfo.idCardNum = data.data.idCardNum
        this.idCardNumCheck(data.data.idCardNum)
      }
      return true
    },
    // 身份证号验证
    async idCardNumCheck(idCardNum) {
      this.accountInfo.sex = "";
      // 年龄
      var age = this.comUtils.getAgeByIdCardNo(idCardNum)
      if (age !== null && age !== undefined && age !== "") {
        this.accountInfo.age = age
      }
      // 性别
      if (this.comUtils.getSexByIdCardNo(idCardNum) == "01") {
        this.accountInfo.sex = "01";
      } else if (this.comUtils.getSexByIdCardNo(idCardNum) == "02") {
        this.accountInfo.sex = "02";
      }

      // 查询学员信息
      const data = await getStudentInfo(idCardNum,"");
      if (data.data != null) {
        this.accountInfo.userName = data.data.name
        this.accountInfo.telNo = data.data.telNo
        this.accountInfo.idPhotoUrl = data.data.idPhotoUrl
      } else {
        // this.accountInfo.userName = ""
        // this.accountInfo.idPhotoUrl = ""
        // this.accountInfo.age = ""
        // this.accountInfo.sex = ""
      }
      return true;
    },
    // 添加头像
    selectPhoto() {
      this.$refs.fileSelect.click();
    },
    fileSelected() {
      let files = this.$refs.fileSelect.files;
      var msg = this.comUtils.fileUploadCheck(files[0],'img')
      if (msg.snackbarText != '') {
        Vue.prototype.$valertbar.show(msg.snackbarText);
      } else {
        if (files[0]) {
          this.upload(files);
          // 已选择上传图片标识
          this.accountInfo.uploadFlg = true;
        } else {
          this.accountInfo.uploadFlg = false;
        }
      }
    },
    async upload(files) {
      var formData = new FormData();
      formData.append("file", files[0]);
      const data = await upload(formData);
      this.accountInfo.idPhotoUrl = data[0];
    },
    // 添加编辑页面返回值
    set(value) {
      if (value == 1) {
        // 成功 页面刷新
        this.doBack();
      }
    },
  },
  destroyed() {
    Hub.$off("modal-confirm", this.set);
  },
};
</script>

<style lang="scss" scoped>
.main2 {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin-left: 50px;
}
.search-functions {
  position: relative;
  top: 0;
  display: flex;
  margin-left: 300px;
}
.label {
  margin-left: 60px;
  margin-right: 10px;
  margin-top: 10px;
}
.title {
  margin-left: 20px;
}
.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}
.video-box {
  display: flex;
  width: 700px;
  height: 300px;
  margin: 50px 0;
}
.item {
  margin-left: 3px;
  margin-right: 3px;
}
.inner-box {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  position: relative;
}
.main1 {
  margin-left: 135px;
  margin-top: 10px;
}
.hidden {
  display: none;
}
</style>
